import React from 'react';

const MARK_SRC = '/brand/forsyth-mark.png';

// Circular mark only (used for compact spots, sidebar, headers)
export function LogoMark({
  size = 40,
  className = '',
}: {
  size?: number;
  className?: string;
}) {
  return (
    <img
      src={MARK_SRC}
      alt="A. Forsyth & Son"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`shrink-0 object-contain ${className}`}
    />
  );
}

// Horizontal lockup: circular mark on left + wordmark text on right
export function LogoLockup({
  size = 44,
  color = 'dark',
  className = '',
  compact = false,
}: {
  size?: number;
  color?: 'dark' | 'light';
  className?: string;
  compact?: boolean;
}) {
  const primaryColor = color === 'light' ? '#ffffff' : '#0a3b7a';
  const secondaryColor = color === 'light' ? '#cfd6df' : '#6b7280';
  const accentColor = '#804d20'; // brown/copper from the logo brief
  const mutedColor = color === 'light' ? 'rgba(255,255,255,0.65)' : '#94a3b8';

  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      <div className="flex flex-col leading-none">
        <span
          style={{ color: primaryColor }}
          className={`font-black tracking-tight ${compact ? 'text-[13px]' : 'text-[15px]'}`}
        >
          A FORSYTH{' '}
          <span style={{ color: secondaryColor }}>&amp; SON</span>
        </span>
        <span
          style={{ color: mutedColor }}
          className={`font-bold uppercase mt-1 ${compact ? 'text-[8px] tracking-[0.18em]' : 'text-[9px] tracking-[0.2em]'}`}
        >
          Plumbing{' '}
          <span style={{ color: accentColor }}>|</span> Groundworks
        </span>
      </div>
    </div>
  );
}

// Full original logo file (with wordmark stacked below the circle) — used on login hero
export function LogoFull({
  height = 100,
  className = '',
}: {
  height?: number;
  className?: string;
}) {
  return (
    <img
      src="/brand/forsyth-logo.png"
      alt="A. Forsyth & Son · Plumbing & Groundworks, Huntly"
      style={{ height, width: 'auto' }}
      className={`shrink-0 ${className}`}
    />
  );
}
